<template>
    <div class="Workload_statistics">
        <el-form :inline="true" class="filter-form" label-width="85px">
            <el-form-item label="姓名：">
                <el-input v-model="filters.name" placeholder="请输入姓名" clearable />
            </el-form-item>
            <el-form-item label="审核：">
                <el-radio-group v-model="filters.status">
                    <el-radio label="">全部</el-radio>
                    <el-radio label="1">审核</el-radio>
                    <el-radio label="0">未审核</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="统计时间：">   
                <el-date-picker
                    style="width: 260px;"
                    v-model="dateRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                />
            </el-form-item>
            <el-form-item label-width="20px">
                <el-button type="primary" @click="onSearch">搜索</el-button>
                <el-button @click="onReset">重置条件</el-button>
            </el-form-item>
        </el-form>
        <main v-loading="Workloadstatisticsloading">
            <div class="table_title">
                <el-button type="primary" @click="Profitallocation">收益配置</el-button>
                <el-upload
                    class="upload-demo"
                    action=""
                    :accept="'.xlsx,.xls'"
                    :before-upload="onBeforeUpload"
                    :http-request="customUpload"        
                    :show-file-list="false">
                    <el-button type="primary">导入</el-button>
                </el-upload>
                <el-button type="primary" @click="onExport" :loading="exportLoading">导出</el-button>
                <el-button type="primary" @click="onDownloadTemplate">下载模板</el-button>
                <el-button type="primary" @click="singleAudit(filters.ids,0)">审批选中</el-button>
            </div>

            <div class="describe">
                <div>
                    <label>说明：</label>
                    <div>1. 一项工作只填一行数据，工作类别按实际情况三选一即可：例会、培训、实践。实践的劳务费自动生成，例会、培训只作记录，不涉及劳务费。<br>
                        2. 心理中心微信公众号工作时长和工作内容按照《"国科大心理中心"微信公众号稿费、劳务费及奖励制度》填写，稿费请按劳务费标准换算成工作时长。</div>
                </div>
                <span>劳务费合计:{{totalFee}}</span>
            </div>

            <el-table :data="tableData" style="width: 100%;" @selection-change="handleSelectionChange" >
                <el-table-column type="selection" width="55"/>
                <el-table-column label="姓名" >
                    <template slot-scope="scope" >
                        <el-autocomplete 
                        v-if="scope.row.createStatus"
                        v-model="addParams.realName"
                        :fetch-suggestions="querySearch" 
                        :trigger-on-focus="false"
                        placeholder="输入并选择姓名" 
                        @select="handleSelect" >
                            <template slot-scope="{ item }">
                                <div class="name">{{ `${item.realName}(${item.userID})` }}</div>
                            </template>
                        </el-autocomplete>
                        <el-autocomplete 
                        v-else-if="chooseworkDetailKey==scope.row.workDetailKey"
                        v-model="scope.row.realName"
                        :fetch-suggestions="querySearch" 
                        :trigger-on-focus="false"
                        placeholder="输入并选择姓名" 
                        @select="handleSelect" >
                            <template slot-scope="{ item }">
                                <div class="name">{{ `${item.realName}(${item.userID})` }}</div>
                            </template>
                        </el-autocomplete>
                        <span v-else>{{ scope.row.realName }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="workDate" label="工作日期" width="170">
                    <template slot-scope="scope">
                        <el-date-picker 
                        v-if="scope.row.createStatus"
                        v-model="addParams.workDate"
                        type="date" 
                        placeholder="选择日期" 
                        value-format="yyyy-MM-dd" 
                        format="yyyy-MM-dd" 
                        style="width:140px;"
                        />
                        <el-date-picker 
                        v-else-if="chooseworkDetailKey==scope.row.workDetailKey"
                        v-model="scope.row.workDate"
                        type="date" 
                        placeholder="选择日期" 
                        value-format="yyyy-MM-dd" 
                        format="yyyy-MM-dd" 
                        style="width:140px;"
                        />
                        <span v-else>{{ scope.row.workDate }}</span>
                        <el-tooltip v-if="scope.row.createStatus || chooseworkDetailKey==scope.row.workDetailKey" class="input-with-tooltip"
                            effect="dark"
                            content="若为推文，请按实际发布日期填"
                            placement="top"
                        >
                            <i class="el-icon-question tooltip-icon"></i>
                        </el-tooltip>  
                    </template>
                </el-table-column>
                <el-table-column prop="content" label="工作内容">
                    <template slot-scope="scope" >
                        <el-input 
                        v-if="scope.row.createStatus"
                        v-model="addParams.content" 
                        />
                        <el-input 
                        v-else-if="chooseworkDetailKey==scope.row.workDetailKey"
                        v-model="scope.row.content" 
                        />
                        <span v-else>{{ scope.row.content }}</span>
                        <el-tooltip v-if="scope.row.createStatus || chooseworkDetailKey==scope.row.workDetailKey" class="input-with-tooltip"
                            effect="dark"
                            content="若为稿件，仅写稿件发布标题"
                            placement="top"
                        >
                            <i class="el-icon-question tooltip-icon"></i>
                        </el-tooltip>  
                    </template>
                </el-table-column>
                <el-table-column prop="role" label="工作角色" >
                    <template slot-scope="scope" >                    

                        <el-input 
                        v-if="scope.row.createStatus"
                        v-model="addParams.role" 
                        placeholder="输入角色" 
                        />
                       
                        <el-input 
                        v-else-if="chooseworkDetailKey==scope.row.workDetailKey"
                        v-model="scope.row.role" 
                        placeholder="输入角色" 
                        />
                        <span v-else>{{ scope.row.role }}</span>
                          <el-tooltip v-if="scope.row.createStatus || chooseworkDetailKey==scope.row.workDetailKey" class="input-with-tooltip"
                            effect="dark"
                            content="撰稿、图片、约稿、整理、审校、编辑、制图、责编、培训、参训、参会、其他"
                            placement="top"
                        >
                            <i class="el-icon-question tooltip-icon"></i>
                        </el-tooltip>           
                    </template>
                </el-table-column>
                <el-table-column prop="quantity" label="数量">
                    <template slot-scope="scope" >
                        <el-input 
                        v-if="scope.row.createStatus"
                        v-model="addParams.quantity" 
                        type="number"
                        min="0"
                        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                        />
                        <el-input 
                        v-else-if="chooseworkDetailKey==scope.row.workDetailKey"
                        v-model="scope.row.quantity" 
                        type="number"
                        min="0"
                        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                        />
                        <span v-else>{{ scope.row.quantity }}</span>
                        <el-tooltip v-if="scope.row.createStatus || chooseworkDetailKey==scope.row.workDetailKey" class="input-with-tooltip"
                            effect="dark"
                            content="文字/图片/制图的数量，文字仅标题和正文，不包含参考文献的字数"
                            placement="top"
                        >
                            <i class="el-icon-question tooltip-icon"></i>
                        </el-tooltip>  
                    </template>
                </el-table-column>
                <el-table-column prop="duration" label="工作时长（小时）">
                    <template slot-scope="scope" >
                        <el-input 
                        v-if="scope.row.createStatus"
                        v-model="addParams.duration" 
                        placeholder="精确1位小数" 
                        @input="calculateFirstRowSalary"
                        />
                        <el-input 
                        v-else-if="chooseworkDetailKey==scope.row.workDetailKey"
                        v-model="scope.row.duration" 
                        placeholder="精确1位小数" 
                        />
                        <span v-else>{{ scope.row.duration }}</span>
                        <el-tooltip v-if="scope.row.createStatus || chooseworkDetailKey==scope.row.workDetailKey" class="input-with-tooltip"
                            effect="dark"
                            content="精确到小数点后1位"
                            placement="top"
                        >
                            <i class="el-icon-question tooltip-icon"></i>
                        </el-tooltip>  
                    </template>
                </el-table-column>
                <el-table-column prop="type" label="工作类别" >
                    <template slot-scope="scope" >
                        <el-select 
                        v-if="scope.row.createStatus"
                        v-model="addParams.type"    
                        placeholder="请选择"
                        @change="calculateFirstRowSalary">
                            <el-option label="实践" :value="1" />
                            <el-option label="例会" :value="2" />
                            <el-option label="培训" :value="3" />
                        </el-select>
                        <el-select 
                        v-else-if="chooseworkDetailKey==scope.row.workDetailKey"
                        v-model="scope.row.type" 
                        placeholder="请选择">
                            <el-option label="实践" :value="1" />
                            <el-option label="例会" :value="2" />
                            <el-option label="培训" :value="3" />
                        </el-select>
                        <span v-else>{{scope.row.typeStr}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="salary" label="劳务费">
                    <template slot-scope="scope" >
                        <span v-if="!scope.row.createStatus">{{ scope.row.salary }}</span>
                        <span v-else>{{ firstRowSalary }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注">
                    <template slot-scope="scope" >
                        <el-input 
                        v-if="scope.row.createStatus"
                        v-model="addParams.remark" 
                        />
                        <el-input 
                        v-else-if="chooseworkDetailKey==scope.row.workDetailKey"
                        v-model="scope.row.remark" 
                        />
                        <span v-else>{{ scope.row.remark }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="creatorName" label="录入人">
                    <template slot-scope="scope" >
                        <span v-if="!scope.row.createStatus">{{ scope.row.creatorName }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="updaterName" label="最后修改人">
                    <template slot-scope="scope" >
                        <span v-if="!scope.row.createStatus">{{ scope.row.updaterName }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="auditStatus" label="审核状态">
                    <template slot-scope="scope" >
                        <span>{{ scope.row.auditStatus==2?'拒绝':scope.row.auditStatus==1?'通过':scope.row.createStatus?'':'待审核' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope" >
                        <template v-if="scope.row.createStatus">
                            <el-button type="text" size="mini" @click="singleSave()" :loading="saveLoading">保存</el-button>
                        </template>
                        <template v-else>
                            <el-button type="text" size="mini" @click="singleAudit(scope.row,1)" v-if="scope.row.auditStatus==0">审核</el-button>
                            <el-button type="text" size="mini" @click="singleEdit(scope.row)" v-if="(scope.row.auditStatus==0 || Global.pdroleid(1084) || Global.pdroleid(1057)) && chooseworkDetailKey!=scope.row.workDetailKey">编辑</el-button>
                            <el-button type="text" size="mini" @click="singleCancel(scope.row)" v-if="chooseworkDetailKey==scope.row.workDetailKey">取消</el-button>
                            <el-button type="text" size="mini" @click="singlerowSave(scope.row)" v-if="chooseworkDetailKey==scope.row.workDetailKey">保存</el-button>
                            <el-popconfirm title="是否删除该条记录？" @confirm="singleDelete(scope.row)">
                                <el-button slot="reference" type="text" size="mini" style="color: #F56C6C;">删除</el-button>
                            </el-popconfirm>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </main>

        <!-- 收益配置 -->
        <el-dialog title="收益配置" :visible.sync="dialogVisible" width="480px">
            <p class="sub_describe">实践劳务费标准{{PracticalfeeCurr}}元/小时，培训、例会无劳务费，不涉及。</p>
            <el-form :model="form" label-width="100px">
                <el-form-item label="实践劳务费">
                    <el-input style="width: 240px;" v-model="Practicalfee"/> 元/小时
                </el-form-item>
                <el-form-item label="收益生效时间">
                    <div class="block">
                        <el-date-picker
                        v-model="incomeDate"
                        type="date"
                        placeholder="选择日期"
                        :picker-options="pickerOptions"
                        value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                        >
                        </el-date-picker>
                    </div>
                </el-form-item>
                <el-form-item label-width="20px">
                    <el-button type="primary" @click="onSave">保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data(){
        return {
            firstRowSalary: '-', // 存储第一行的劳务费  
            saveLoading:false,            
            dialogVisible:false,
            PracticalfeeCurr:25,
            incomeDate:"",
            Practicalfee:'',
            form:{
                practiceFee:'',
            },
            filters: {
                workDetailKey:'',
                name: '',
                status:'',
                from:'',
                to:'',
                exportFlag:'0',
                ids:[],
                mode:0
            },
            addParams:{
                realName:'',
                userID:'',
                workDate:'',
                type:'',//1-实践 2-例会 3-培训
                content:'',
                role:'',
                quantity:'',
                duration:'',
                remark:'',
                createStatus:true,
            },
            dateRange: [],
            tableData: [
                {userID:'',workDate:'',type:'',content:'',role:'',quantity:'',duration:'',remark:''}
            ],
            Workloadstatisticsloading:false,
            restaurants:[],
            exportLoading:false,
            totalFee:'',
            chooseworkDetailKey:'',
            pickerOptions: {
                disabledDate: (time) => {
                //console.log('pickerOptions disabledDate 被调用', time);
                if (!time) return false;
                
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                return time.getTime() < today.getTime();
                }
            }
        }
    },
    watch:{
        dateRange(newval){
            if(newval==null){
                this.filters.from=''
                this.filters.to=''
            }else{
                this.filters.from=newval[0]
                this.filters.to=newval[1]
            }
        }
    },
    created(){
        console.log('$http:', this.$http);
        console.log('$axios:', this.$axios);
        console.log('$api:', this.$api);
        this.onSearch();
        this.getUserList();
        this.incomeValueCurr();
    },
    methods:{
        // 计算第一行的劳务费
        calculateFirstRowSalary() {
            let salary = 0;
            
            // 检查是否有所需的数据
            if (!this.addParams.type || !this.addParams.duration) {
                this.firstRowSalary = '-';
                return;
            }
            
            // 将时长转换为数字
            const duration = parseFloat(this.addParams.duration);
            
            // 检查时长是否为有效数字
            if (isNaN(duration) || duration <= 0) {
                this.firstRowSalary = '-';
                return;
            }
            
            // 根据工作类别计算劳务费
            if (this.addParams.type == 1) { // 实践
                salary = duration * this.PracticalfeeCurr;
            } else if (this.addParams.type == 2 || this.addParams.type == 3) { // 例会或培训
                salary = 0;
            }
            
            // 格式化显示（保留2位小数）
            this.firstRowSalary = salary.toFixed(2);
        },
        getUserList(){
            this.$Http_Post('/User/GetSimpleUserList',{userInfo:'',pageIndex:1,pageSize:100000}).then(res=>{
                if(res.Code==200 || res.Code==0){
                    this.restaurants=res.Data
                }
            })
        },
        // 获取用户列表
        querySearch(queryString, cb) {
            var restaurants = this.restaurants;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        // 自定义上传方法
        customUpload(options) {
            const formData = new FormData();
            formData.append('file', options.file);
            
            console.log('开始上传文件:', options.file.name);
            
            // 使用您项目中正确的请求方法
            this.$Http_Post('/management/importSalary', formData, {
                headers: { 
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
                console.log('上传响应:', response);
                if (response.Code === 200 || response.Code === 0) {
                    this.$message.success(response.Message || '导入成功');
                    this.onSearch();
                } else {
                    this.$message.error(response.Message || '导入失败');
                }
                options.onSuccess(response);
            }).catch(error => {
                console.error('上传失败:', error);
                let errorMsg = '导入失败';
                if (error.response && error.response.data) {
                    errorMsg = error.response.data.Message || errorMsg;
                }
                this.$message.error(errorMsg);
                options.onError(error);
            });
        },
        createFilter(queryString) {
            return (restaurant) => {
                return (restaurant.realName.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        handleSelect(item){
            if(this.chooseworkDetailKey==""){
                this.addParams.realName=item.realName
                this.addParams.userID=item.userID;
            }else{
                this.tableData=this.tableData.map(items=>{
                    if(items.workDetailKey==this.chooseworkDetailKey){
                        items.userID=item.userID;
                        items.realName=item.realName
                    }
                    return items;
                });
            }
            
        },
        onSearch(){
            this.$Http_Post('/management/getSalaryList',this.filters).then(res=>{
                this.filters.exportFlag=0;
                this.Workloadstatisticsloading=false;
                if(res.Code==200 || res.Code==0){
                    this.totalFee=res.Data.reduce((total,item)=>total+parseInt(item.salary),0);
                    this.tableData=[this.addParams,...res.Data];
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        onReset() {
            this.filters = this.$options.data().filters;
            this.dateRange = [];
            this.onSearch()
        },
        // 添加
        singleSave(){
            if(this.addParams.realName=='' ||this.addParams.workDate=='' || this.addParams.type=='' || this.addParams.content=='' || this.addParams.role=='' || this.addParams.quantity=='' || this.addParams.duration==''){
                this.$message.error('请填写完整信息')
                return false;
            }
            if(this.addParams.userID==''){
                this.$message.error("请从姓名搜索列表中选择用户")
                return
            }
            this.saveLoading=true;
            this.$Http_Post('/management/addSalary',this.addParams).then(res=>{
                this.saveLoading=false;
                if(res.Code==200 || res.Code==0){
                    this.addParams=this.$options.data().addParams;
                    this.$message.success(res.Message)
                    this.onSearch()
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        Profitallocation(){
            this.dialogVisible=true;
            this.Practicalfee='';
        },
        // 编辑
        singleEdit(row){
           if(this.chooseworkDetailKey!=""){
            this.tableData=this.tableData.map(item=>{
                if(item.workDetailKey==this.chooseworkDetailKey){
                    item=this.chooseItem;
                }
                return item;
            });
           }
            this.chooseworkDetailKey=row.workDetailKey;
            this.chooseItem=JSON.parse(JSON.stringify(row));
        },
        // 取消
        singleCancel(row){
            this.chooseworkDetailKey='';
            this.tableData=this.tableData.map(item=>{
                if(item.workDetailKey==row.workDetailKey){
                    item=this.chooseItem;
                }
                return item;
            })
        },
        // 保存
        singlerowSave(row){
            let data={
                workDetailKey:row.workDetailKey,
                userID:row.userID,
                workDate:row.workDate,
                content:row.content,
                role:row.role,
                quantity:row.quantity,
                duration:row.duration,
                type:row.type,
                remark:row.remark
            }
            this.$Http_Post('/management/auditSalary',data).then(res=>{
                if(res.Code==200 || res.Code==0){
                    this.$message.success(res.Message)
                    this.chooseworkDetailKey=''
                    this.onSearch()
                }else{
                    this.$message.error(res.Message)
                }
            })
        },

        // 审核
        singleAudit(row,status){
            if(status==0 && this.filters.ids.length==0){
                this.$message.error('是否通过审核')
                return false;
            }
            this.$confirm('确定要审核吗?', '提示', {
                distinguishCancelAndClose: true,
                confirmButtonText: '通过',
                cancelButtonText: '拒绝',
                type: 'warning',
                message: '确定要审核吗？'
            }).then(() => {
                this.filters.ids=status==0?this.filters.ids:[row.workDetailKey]
                this.auditSalary(1)
            }).catch((action ) => {
                if(action=='cancel'){
                    this.filters.ids=status==0?this.filters.ids:[row.workDetailKey]
                    this.auditSalary(2)
                }
            });
        },


        auditSalary(status){
            this.$Http_Post('/management/auditSalary',{auditStatus:status,ids:this.filters.ids}).then(res=>{
                if(res.Code==200 || res.Code==0){
                    this.$message.success(res.Message)
                    this.filters.ids=[];
                    this.onSearch()
                }else{
                    this.$message.error(res.Message)
                }
            })
        },

        // 删除
        singleDelete(row){
            this.$Http_Post('/management/removeSalary',{workDetailKey:row.workDetailKey}).then(res=>{
                if(res.Code==200 || res.Code==0){
                    this.$message.success(res.Message)
                    this.onSearch()
                }else{
                    this.$message.error(res.Message)
                }
            })
        },

        // 收益配置
        onSave(){
            // let Date={
            //     CDicValue: this.Practicalfee,
            //     DicKey: "3111",
            //     DicTypCode: 82,
            //     EDicValue: "",
            //     LineNumber: 0
            // }
            // this.$Http_Post('/User/editDictionaryLevelPage',Date).then(res=>{
            //     if(res.Code==200 || res.Code==0){
            //         this.$message.success(res.Message)
            //         this.Practicalfee='';
            //         this.dialogVisible=false;
            //         this.onSearch()
            //     }else{
            //         this.$message.error(res.Message)
            //     }
            // })
            if(!this.Practicalfee){
                this.$message.error('实践劳务费不能为空')
                return false;
            }
            if(!this.incomeDate){
                this.$message.error('收益生效时间不能为空')
                return false;
            }
            let Date={
                incomeValue: this.Practicalfee,
                incomeDate: this.incomeDate
            }
            this.$Http_Post('/management/insertIncome',Date).then(res=>{
                if(res.Code==200 || res.Code==0){
                    this.$message.success(res.Message)
                    this.Practicalfee='';
                    this.dialogVisible=false;
                    this.onSearch();
                    this.incomeValueCurr();
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        incomeValueCurr(){
            this.$Http_Post('/management/getIncomeValueCurr',Date).then(res=>{
                if(res.Code==200 || res.Code==0){
                    //this.$message.success(res.Message)
                    this.PracticalfeeCurr=res.Data;
                }
            })
        },

        // 导出
        onExport(){
            this.exportLoading=true;
            this.filters.exportFlag=1;
            this.$Http_Post('/management/getSalaryList',this.filters).then(res=>{
                this.exportLoading=false;
                this.filters.exportFlag=0;
                if(res.Code==200 || res.Code==0){
                    window.open(res.Data);
                    this.$message.success(res.Message)
                }else{
                    this.$message.error(res.Message)
                }
            })
        },

        // 下载模板
        onDownloadTemplate(){
            window.location.href=process.env.VUE_APP_URL+'/File/TemplateFile/salary_template.xlsx';
        },

        // 导入前
        onBeforeUpload(file){
            console.log('文件验证:', file);
            // 验证文件类型
            const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
                            file.type === 'application/vnd.ms-excel';
            
            // 验证文件后缀名
            const isXLSX = file.name.substring(file.name.lastIndexOf('.')+1).toLowerCase() === 'xlsx';
            
            if (!isExcel || !isXLSX) {
                this.$message.error('上传文件只能是 xlsx 格式!');
                return false;
            }
            return true;
        }, 
        // 多选
        handleSelectionChange(rows){
            this.filters.ids = rows.map(item => item.workDetailKey).filter(key => key !== undefined && key !== null && key !== '');
        },
        
    }
}
</script>
<style scoped>
.Workload_statistics .filter-form{background: #fff;padding: 16px 0 0;margin-bottom: 16px;}
.Workload_statistics main{background: #F0F8FF;padding: 16px;}
.Workload_statistics main .describe{display: flex;justify-content:space-between;align-items: center;color: #606266;border: 1px solid #ebeef5;padding:15px;margin: 20px 0 0;}
.Workload_statistics main .describe span{padding-left: 20px;}
.Workload_statistics main .describe div{display: flex;flex: 1;}
.Workload_statistics main .describe div label{width: 60px;}
.Workload_statistics .sub_describe{color: #8D8D8D;padding: 0 20px 30px;}
.Workload_statistics .upload-demo{display: inline-block;margin: 0 10px;}

.full-width-input {
  width: 100%;
  /* 不需要 padding-right，因为图标是绝对定位在外部 */
}
.tooltip-icon {
  position: absolute;
  right: -3px;  /* 距离右侧 8px */
  top: 50%;    /* 垂直居中 */
  transform: translateY(-50%);  /* 精确垂直居中 */
  color: #409EFF;
  cursor: pointer;
  font-size: 16px;
  z-index: 10;
  background: white;  /* 添加背景避免被输入框边框遮挡 */
  padding: 0px;
  border-radius: 50%;
}
</style>